export const faqs = [
  {
    id: "f1",
    q: "茶杯狐影视这个页面能做什么？",
    a: "这是一个信息聚合型的选片页：把热播剧、电影推荐、蓝光画质资源和高分片单集中整理到一起，方便你按类型、画质和口碑快速缩小范围，再决定去看哪一部。",
  },
  {
    id: "f2",
    q: "「蓝光画质」具体指什么标准？",
    a: "本页把画质分成蓝光 4K、1080P 和 HD 高清三档。蓝光 4K 一般指 3840×2160 左右的片源，画面细节和暗部层次最好；1080P 为 1920×1080 的主流高清；HD 高清多为 720P 及以上。实际观感还会受片源压制方式和设备影响。",
  },
  {
    id: "f3",
    q: "怎么快速找到我想看的类型？",
    a: "可以先用顶部搜索框输入片名、类型或地区关键词，再用「类型」和「画质」两个筛选器收窄结果。所有搜索和筛选都只作用于本页已收录的条目，切换后结果会即时更新。",
  },
  {
    id: "f4",
    q: "页面上的评分是哪个平台的？",
    a: "页面中的评分用于横向比较同类型作品的受认可程度，仅作为选片参考，不代表某一个平台的官方分数，实际以你在观看平台看到的信息为准。",
  },
  {
    id: "f5",
    q: "为什么有的条目在「更新中」？",
    a: "连载类作品会随播出进度更新集数，本页在「今日更新」与卡片上标注了最新进度。标注「已完结」的可以放心一次性看完，标注「更新中」的建议先确认当前集数再决定是否跟播。",
  },
  {
    id: "f6",
    q: "高分片单和普通推荐有什么区别？",
    a: "高分片单是按观看场景重新组合过的清单，比如「深夜悬疑」「陪家人一起看」「一口气追完」，侧重解决“我现在想看点什么”的问题；普通推荐则更偏向单部作品本身的介绍。",
  },
];